import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "controllers"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener("DOMContentLoaded", () => {
  if (window.jQuery && window.jQuery.rails) {
    document.removeEventListener("submit", jQuery.rails.handleRemote);
    document.removeEventListener("click", jQuery.rails.handleRemote);
    delete window.jQuery.rails;
    console.warn("🧨 jquery-ujs disattivato.");
  }
});
